module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "department"
  }, [_c('div', [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.isSystemAdminMode),
      expression: "$store.state.isSystemAdminMode"
    }],
    staticClass: "menu-select",
    on: {
      "change": _vm.handleDepSelect
    },
    model: {
      value: (_vm.depId),
      callback: function($$v) {
        _vm.depId = $$v
      },
      expression: "depId"
    }
  }, _vm._l((_vm.departmentListWithAll), function(dep) {
    return _c('el-option', {
      key: dep.id,
      attrs: {
        "label": dep.title,
        "value": dep.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "department-table"
  }, [_c('el-col', {
    staticClass: "title-bar",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "number-of-deps"
  }, [_vm._v(_vm._s('共 ' + this.actualDepartments.length + ' 個部門'))]), _vm._v(" "), _c('el-button', {
    staticClass: "add-btn",
    on: {
      "click": _vm.showAddDialog
    }
  }, [_vm._v("新增部門\n\t\t\t\t\t"), _c('img', {
    staticClass: "add-icon",
    attrs: {
      "src": require("../../assets/icon/ic_add.png"),
      "alt": "A"
    }
  })])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "display": "inline-block",
      "float": "left"
    },
    attrs: {
      "data": _vm.actualDepartments,
      "row-key": "id",
      "default-sort": {
        prop: 'depid'
      },
      "empty-text": "暫無數據"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "部門"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "隸屬"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t" + _vm._s(scope.row.dep.title) + "\n\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "會員人數"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "可不列入統計的會員比例上限(％)",
      "formatter": _vm.formatExclude
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "delete-icon",
          attrs: {
            "src": require("../../assets/icon/ic_delete_blue.png"),
            "alt": "D"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "edit-icon",
          attrs: {
            "src": require("../../assets/icon/ic_edit_blue.png"),
            "alt": "E"
          },
          on: {
            "click": function($event) {
              return _vm.showEditDialog(scope.row)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alert.display && this.$store.state.nowDepartmentStatus === 1),
      expression: "alert.display && this.$store.state.nowDepartmentStatus === 1"
    }],
    attrs: {
      "warning": _vm.alert.warning,
      "content": _vm.alert.content,
      "title": _vm.alert.title
    },
    on: {
      "close": _vm.closeAlert,
      "delete": function($event) {
        return _vm.deleteDepartment()
      }
    }
  }), _vm._v(" "), _c('hint', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hint.display && this.$store.state.hintStatus.department),
      expression: "hint.display && this.$store.state.hintStatus.department"
    }],
    attrs: {
      "message": _vm.hint.message
    },
    on: {
      "close": _vm.closeHint
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialogTitle,
      "show-close": false,
      "visible": _vm.dialogFormVisible,
      "customClass": "dialogWidth"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部門名稱",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "隸屬",
      "prop": "depId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "請選擇隸屬"
    },
    on: {
      "change": _vm.depSel
    },
    model: {
      value: (_vm.selectedDep),
      callback: function($$v) {
        _vm.selectedDep = _vm._n($$v)
      },
      expression: "selectedDep"
    }
  }, _vm._l((_vm.departmentList), function(dep) {
    return _c('el-option', {
      key: dep.id,
      attrs: {
        "label": dep.title,
        "value": dep.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "可不列入統計的會員比例上限(％)",
      "prop": "limit"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.limit),
      callback: function($$v) {
        _vm.$set(_vm.form, "limit", _vm._n($$v))
      },
      expression: "form.limit"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.isEditDialog) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editActualDep
    }
  }, [_vm._v("儲存")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addActualDep
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-522dbff3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/Department.vue
// module id = 922
// module chunks = 170